export default "__VITE_ASSET__6d38ed86__"